import { useCallback } from 'react';

export const useValidation = () => {
  const validateEmail = useCallback((email) => {
    if (!email) {
      return true;
    }
    //eslint-disable-next-line
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  }, []);

  const validatePassword = useCallback((password) => {
    if (!password) {
      return true;
    }

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    return regex.test(password);
  }, []);

  return { validateEmail, validatePassword };
};
